import React from 'react'
import ProjectStep from "../components/ProjectStep";

export default class DescriptionStep extends ProjectStep {

    static TranslationKey = 'description_step';

    static path = '/description';
    static slug = 'description';

    static ValidationMethodName = 'validateDescription';

    static HandleUnauthorized = false;

    static Optional = true;

    static hasCompleted(project) {
        return project.validateDescription();
    }

    /**
     * @param {project} project
     * @returns {Object}
     */
    static reviewMapping(project) {
        return {
            ['Project Description']: project.description ? <div className="rich-text-display">
                <span dangerouslySetInnerHTML={{__html: project.description}}/>
            </div> : <span className="text-muted">N/A</span>
        }
    }

    /**
     * The fields mapping for the form
     */
    formFields = () => {
        return [
            {
                fields: {
                    description: {
                        type: 'editor',
                        maxLength: 10000,
                        rows: 12,
                        label: 'Describe your project in any way you like, including what help you need:',
                        required: false,
                        placeholder: 'I need to redesign a web site based on the Webflow platform. I' +
                            ' need a great UX resource who has a background with user research. Additionally, we need…'
                    },
                }
            },
        ]
    };
}